import { ownerWeekCopy as t } from "./copy.ts";

export const drawer = { label: t.lugar, href: "/semana" };
